import { BaseModel } from '@Core';
import { VerificationNote } from './VerificationNote';

export interface ContraventionAuditEvent extends BaseModel {
    GroupPotentialContraventionId: number;
    OldValues: Partial<VerificationNote | VerificationChangePlate>;
    NewValues: Partial<VerificationNote | VerificationChangePlate>;
    AuditEventType: ContraventionAuditEventType;
    Notes?: string;
    EntityName: ContraventionAuditEventEntityName;
}

export enum ContraventionAuditEventEntityName {
    Verification = 'Verification',
    VerificationNotes = 'Verification notes',
    PotentialContraventionSync = 'Potential contravention sync',
}

export interface VerificationChangePlate {
    Plate: string;
}

export enum ContraventionAuditEventType {
    Created,
    Updated,
    Deleted,
    Read,

    Cancelled,
    Approved,
    ChangePlate,
    ChangeEvidence,
    LookUp,
    Audit,
    CameraPhotoVehicleUpdated,
    PotentialContraventionPhotoUpdated,

    SyncPCNStella,
}
